// App constants

export const APP_NAME = '5UGC';
export const APP_VERSION = '2.0.0';

// Routes
export const ROUTES = {
  HOME: '/',
  // All other routes are modal-only (no direct page routes):
  // - login, register, forgot-password (auth modals)
  // - profile, paywall (feature modals)
  // - wizard (feature modal)
};

// API
export const API_TIMEOUT = 30000; // 30 seconds
export const MAX_RETRIES = 3;

// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  AUTH_USER: 'auth_user',
  VIDEOS: 'videos',
  USER_PREFERENCES: 'user_prefs',
  DRAFT_DATA: 'draft_data',
  THEME: 'theme',
  APP_LOCALE: 'app_locale',
};

// Wizard steps
export const WIZARD_STEPS = {
  PRODUCT: 0,
  SCRIPT: 1,
  FINALIZE: 2,
};

// Pagination
export const DEFAULT_PAGE_SIZE = 20;

// File limits
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

// Blocked email patterns (demo/test accounts not allowed)
export const BLOCKED_EMAIL_PATTERNS = [
  /^demo@/i,
  /^test@/i,
  /^fake@/i,
  /^guest@/i,
  /^admin@/i,
  /^example@/i,
  /^user@/i,
  /^sample@/i,
  /^placeholder@/i,
  /@example\.com$/i,
  /@test\.com$/i,
  /@demo\.com$/i,
  /@fake\.com$/i,
  /@placeholder\.com$/i,
  /@mailinator\.com$/i,
  /@tempmail\./i,
  /@throwaway\./i,
];
